// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import config from 'config.json';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;
const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
const IS_STAGING = process.env.IS_SLINGSHOT === 'true';

Sentry.init({
  ...(!IS_DEVELOPMENT && IS_STAGING ? { environment: 'staging' } : {}),
  enabled: !IS_DEVELOPMENT,
  dsn:
    SENTRY_DSN ||
    'https://92d6a6a16de944af8407d227e8e66364@o22381.ingest.sentry.io/5777168',
  autoSessionTracking: false,
  allowUrls: config.sentryAllowUrls,
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
});
